import React from 'react'
import { useTranslation } from 'react-i18next'
import { match } from 'ts-pattern'

import Spinner from '@/components-latest/primitives/Spinner'
import Text from '@/components-latest/primitives/Text'
import Styles from '@/components-latest/ui/OrdersPage/HistoryOrders/HistoryOrders.module.scss'
import OrderDetails from '@/components-latest/ui/OrdersPage/OrderDetails'
import { OrderItem } from '@/ducks/orders/slices/orders.slice'

export const SearchResults: React.FC<{
  isLoading: boolean
  orders?: OrderItem[] | null
}> = ({ orders, isLoading }) => {
  const { t } = useTranslation()

  return (
    <>
      {match({
        orders,
        isLoading
      })
        .with({ isLoading: true }, () => (
          <div className={Styles.message}>
            <Spinner />
          </div>
        ))
        .with(
          { isLoading: false },
          ({ orders }) => orders && orders.length === 0,
          () => (
            <div className={Styles.message}>
              <img
                className={Styles.imageForEmpty}
                src="/images/empty-orders-search.svg"
                alt="Waiting for orders history"
              />
              <Text variant="title-3" gutter={8}>
                {t('orders.history-search-empty-title')}
              </Text>
              <Text variant="subtitle" className={Styles.dimmed}>
                {t('orders.empty-history-search-message')}
              </Text>
            </div>
          )
        )
        .when(
          ({ orders }) => orders && orders.length > 0,
          ({ orders }) =>
            orders!.map(order => (
              <OrderDetails
                key={order.id}
                order={order as unknown as OrderItem}
              />
            ))
        )
        .otherwise(() => null)}
    </>
  )
}
